import { __decorate } from "tslib";
import { RegisterServiceError, ServiceError, STATUS } from '@cbbt/lib-interface';
let IndividualRecordNotFoundError = class IndividualRecordNotFoundError extends ServiceError {
};
IndividualRecordNotFoundError = __decorate([
    RegisterServiceError({
        status: STATUS.NOT_FOUND,
        message: 'No Record Found',
    })
], IndividualRecordNotFoundError);
export { IndividualRecordNotFoundError };
//# sourceMappingURL=IndividualRecordNotFoundError.js.map